import { useSelector } from "react-redux";
import { MasterConfigs } from "../../interfaces/entity";
import { Typography } from "antd";
const { Title } = Typography;

export const useExperianceConfig = () => {

    const { app: { user } } = useSelector((state: any) => ({
        app: state.app
    }));

    const ExperianceConfig: MasterConfigs = {
        api: () => `/experiance/${user?._id}`,
        modalTitle: () => "Edit User",
        maskClosable: false,
        getFormColumns: () => [
            {
                type: "custom",
                formItem: () => <Title level={5}>Work Experiance</Title>,
                span: 24
            },
            {
                label: "Work Experiance",
                name: "experiance",
                type: "form",
                span: 24,
                form: [
                    {
                        label: "Employee Id",
                        name: "employeeId",
                        type: "text",
                        rules: [{ required: true, message: "Employee Id is required" }]
                    },
                    {
                        label: "Company Name",
                        name: "companyName",
                        type: "text",
                        rules: [{ required: true, message: "Company Name is required" }]
                    },
                    {
                        label: "Designation",
                        name: "designation",
                        type: "text",
                        rules: [{ required: true, message: "Designation is required" }]
                    },
                    {
                        label: "Location",
                        name: "location",
                        type: "text",
                        rules: [{ required: true, message: "Location is required" }]
                    },
                    {
                        label: "Start Date",
                        name: "startDate",
                        type: "date",
                        dateProps: { format: "DD MMM YYYY" },
                        rules: [{ required: true, message: "Start Date is required" }]
                    },
                    {
                        label: "End Date",
                        name: "endDate",
                        type: "date",
                        dateProps: { format: "DD MMM YYYY" },
                        rules: [{ required: true, message: "End Date is required" }]
                    },
                    {
                        label: "Total Experience",
                        name: "totalExperience",
                        type: "text",
                        rules: [{ required: true, message: "Total Experience is required" }]
                    }
                ]
            }
        ]
    }

    return ExperianceConfig;
}
